/**
 * Helper to determine search radius based on filters
 * @param filterParams - Parsed filter parameters
 * @param currentRadius - Current search radius value
 * @param autoSearchRadius - Auto search radius from filters
 * @returns Calculated search radius value
 */
export const determineSearchRadius = (
  filterParams,
  currentRadius,
  autoSearchRadius
) => {
  if (filterParams?.virtualCare && !filterParams?.searchRadius) {
    return -1;
  }
  return currentRadius ?? autoSearchRadius;
};
